module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/MyLoan",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyLoan"
    }
  }, [_vm._v("生源地贷款")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseVisible),
      expression: "chooseVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("未办理生源地贷款")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("已办理生源地贷款")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextLoan()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loanInfoVisible),
      expression: "loanInfoVisible"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', [_c('el-form', {
    ref: "loanForm",
    staticStyle: {
      "width": "50%",
      "margin": "20px auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.loanForm,
      "label-width": _vm.formLabelWidth,
      "size": "medium",
      "inline-message": true,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "贷款银行"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.loanForm.bankType),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "bankType", $$v)
      },
      expression: "loanForm.bankType"
    }
  }, _vm._l((_vm.bankTypeList), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.loanForm.studentName))])]), _vm._v(" "), _c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "学号"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.loanForm.keyInfo))])]), _vm._v(" "), _c('el-form-item', {
    key: "Mobile",
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "联系电话",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "mobile", $$v)
      },
      expression: "loanForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    key: "Loan_Amount",
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "贷款金额",
      "prop": "loanAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanForm.loanAmount),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "loanAmount", $$v)
      },
      expression: "loanForm.loanAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "remark", $$v)
      },
      expression: "loanForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "贷款受理证明或回执单"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUploadLoan,
      "on-success": _vm.successUploadLoan,
      "on-error": _vm.errorUploadLoan,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveLoan,
      "before-remove": _vm.beforeRemoveLoan,
      "limit": 1,
      "on-exceed": _vm.handleExceedLoan,
      "on-change": _vm.handleUploadChangeLoan,
      "file-list": _vm.loanFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证国徽面照片"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUploadUidJust,
      "on-success": _vm.successUploadUidJust,
      "on-error": _vm.errorUploadUidJust,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveUidJust,
      "before-remove": _vm.beforeRemoveUidJust,
      "limit": 1,
      "on-exceed": _vm.handleExceedUidJust,
      "on-change": _vm.handleUploadChangeUidJust,
      "file-list": _vm.uidJustFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证人像面图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUploadUidBack,
      "on-success": _vm.successUploadUidBack,
      "on-error": _vm.errorUploadUidBack,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveUidBack,
      "before-remove": _vm.beforeRemoveUidBack,
      "limit": 1,
      "on-exceed": _vm.handleExceedUidBack,
      "on-change": _vm.handleUploadChangeUidBack,
      "file-list": _vm.uidBackFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他证明图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadDataOther,
      "before-upload": _vm.beforeUploadOther,
      "on-success": _vm.successUploadOther,
      "on-error": _vm.errorUploadOther,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveOther,
      "before-remove": _vm.beforeRemoveOther,
      "multiple": "",
      "limit": 3,
      "on-exceed": _vm.handleExceedOther,
      "on-change": _vm.handleUploadChangeOther,
      "file-list": _vm.otherFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextLoanInfo()
      }
    }
  }, [_vm._v("贷款资料备案上报")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedVisible),
      expression: "speedVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addVisible),
      expression: "addVisible"
    }],
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("状态：提交成功。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("贷款资料备案上报成功，请等待审核结果。")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.home()
      }
    }
  }, [_vm._v("回首页")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successVisible),
      expression: "successVisible"
    }],
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("状态：审核通过。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("恭喜你 " + _vm._s(_vm.dataDt) + " 号上报的贷款资料信息已经通过审核，生源地贷款可抵用学费和住宿费 " + _vm._s(_vm.amount) + " 元。")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextPayFee()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorVisible),
      expression: "errorVisible"
    }],
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("状态：审核退回。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("您可选择修改资料重新上报，或者放弃上报进入缴费流程。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("原因：" + _vm._s(_vm.memo))])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.update()
      }
    }
  }, [_vm._v("修改资料")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextPayFee()
      }
    }
  }, [_vm._v("放弃上报")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "微信二维码",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.weixin
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-439cc157","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XiFan/LoanXiFan.vue
// module id = 1272
// module chunks = 1